import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { useAuth } from '../context/AuthContext';
import { FaUser, FaBirthdayCake, FaUserTag, FaSave, FaArrowLeft } from 'react-icons/fa';
import '../styles/Membres.css';

const Profil = () => {
  const { profile, currentUser } = useAuth();
  const [name, setName] = useState('');
  const [birthdate, setBirthdate] = useState('');
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (profile) {
      setName(profile.name || '');
      setBirthdate(profile.birthdate || '');
    }
  }, [profile]);

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg('');

    const { error } = await supabase
      .from('profiles')
      .update({ name: name.trim(), birthdate: birthdate || null })
      .eq('id', currentUser.id);

    setLoading(false);
    if (error) {
      setMsg("Erreur lors de la mise à jour : " + error.message);
    } else {
      setMsg("Profil mis à jour avec succès !");
    }
  };

  const getRoleLabel = (role) => {
    if (role === 'admin') return '👑 Administrateur';
    if (role === 'director') return '🎬 Metteuse en scène';
    return '🎭 Comédien(ne)';
  };

  return (
    <div className="membres-container">
      <div style={{ marginBottom: '20px' }}>
        <Link to="/espace-membres" className="membres-btn">
          <FaArrowLeft /> Retour à l'Espace Membres
        </Link>
      </div>

      <h2>Mon Profil</h2>
      <div className="tab-content" style={{ maxWidth: '500px', margin: '0 auto' }}>
        <form onSubmit={handleSave} className="membres-form">
          <label style={{ display: 'block', marginBottom: '8px' }}>
            <FaUser style={{ marginRight: '8px' }} /> Nom / Prénom d'affichage :
          </label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            style={{ width: '100%', marginBottom: '15px' }}
          />

          <label style={{ display: 'block', marginBottom: '8px' }}>
            <FaBirthdayCake style={{ marginRight: '8px' }} /> Date d'anniversaire :
          </label>
          <input
            type="date"
            value={birthdate}
            onChange={(e) => setBirthdate(e.target.value)}
            style={{ width: '100%', marginBottom: '15px' }}
          />

          <div className="info-box" style={{ marginTop: '10px', marginBottom: '15px' }}>
            <p><FaUserTag /> <strong>Rôle dans la troupe :</strong> {getRoleLabel(profile?.role)}</p>
            <p>📧 <strong>Email :</strong> {profile?.email}</p>
          </div>

          {msg && <p style={{ color: '#007bff', marginBottom: '15px' }}>{msg}</p>}

          <button type="submit" className="membres-btn" disabled={loading} style={{ width: '100%' }}>
            <FaSave /> {loading ? 'Enregistrement...' : 'Enregistrer les modifications'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Profil;